import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-curriculo-dialog',
  templateUrl: './curriculo-dialog.component.html',
  styleUrls: ['./curriculo-dialog.component.scss']
})
export class CurriculoDialogComponent implements OnInit {

  public content: string;
  public form: FormGroup;
  public submiting: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private fb: FormBuilder,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<CurriculoDialogComponent>,
    private snackbar: MatSnackBar
  ) {
    this.content = data//.replace(/\n/gmi, '<br/>');
    this.form = this.fb.group({
      content: [data, Validators.required]
    })
  }

  ngOnInit(): void {

    const subject: Subject<any> = new Subject<any>();
    subject.subscribe((result: any) => {
      const { trigger } = result;
      this.submiting = trigger == 'pre';
    })
    this.http.setLoadingIndicator(subject);

  }

  onPaste(args: any) {
    args.preventDefault();
  }

  onSubmit() {

    if (this.form.valid) {

      const user = JSON.parse(localStorage.getItem('token'));
      const data = this.form.getRawValue();

      data['userId'] = user.id;

      this.http.save('curriculo:update', data)
        .subscribe(
          (result: any) => {
            this.dialogRef.close();
            this.snackbar.open('Curriculo atualizado com sucesso!', 'OK');
          },
          (err: any) => this.errorReport.showMessage(err)
        )
      // console.log('FORM', data)
    }

  }

}
